module.exports = __webpack_public_path__ + "static/media/traditional.2981b66b.svg";